import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { FancyShareApi } from 'api/ApiHelper';
import { ResponseDto } from '@diritto/common/base/response.dto';
import { FancyShareUpdateDto } from '@diritto/common/fancyShare/dtos/fancy-share-edit.dtos';

type UpdateVariables = { fancyShareId: number; data: FancyShareUpdateDto };

export const useUpdateFancyShareMutation = (options?: UseMutationOptions<ResponseDto, unknown, UpdateVariables>) =>
  useMutation({
    mutationFn: ({ fancyShareId, data }: UpdateVariables) => FancyShareApi.updateFancyShare(fancyShareId, data),
    ...options,
  });
